export default {
    'posting-type': 'Patrón de Registro',
    'accountant-then-warehouser': 'Contador y luego almacenista',
    'warehouser-then-accountant': 'Almacenista y luego contador',
    'no-priority': 'Sin prioridades',
    'customize-financial-files': 'Personalizar Archivos Financieros',
    'customized-financial-files': 'Archivos Financieros Personalizados',
    'customize-setting': "Customize Setting",
    'setting-name': "Setting Name",
    'un-customize-setting': "Uncustomize Setting",
    'un-customize-setting-description': "Are you sure you want to uncustomize this setting, knowing that the system-level setting will be applied?",
    'un-customize': "Uncustomize",
    'Posting Pattern': {
      "title": 'Prioridad de Registro',
      "icon": '<i class="fas fa-sort-amount-down-alt primary--text"></i>'
  },
    'showCounterAccount': {
        "title": "Mostrar Cuenta Contraparte",
        "icon": '<i class="fas fa-user-alt primary--text"></i>'
    },
    "useAltCurrencyBalancing": {
        "title" : "Balanceo de Bonos en Moneda Alternativa",
        "icon": '<i class="fas fa-balance-scale primary--text"></i>'
    } ,
    "QtyColor": {
        "title": "Alerta de cantidad al exceder los límites del material",
        "icon": '<i class="fas fa-exclamation-circle primary--text"></i>'
    },
    "ValidateAccountType": {
        "title": "Restringir cuentas finales – Solo comercio",
        "icon": "<i class='fas fa-user-alt-slash primary--text'></i>"
    },      
    "UseDocNoInsteadOfInvoiceNo": {
        "title": "Mostrar el número de documento manual en lugar del número de factura en el informe del mayor",
        "icon": "<i class='mdi mdi-numeric primary--text'></i>"
    },
    "ShowDateEntry": {
        "title": "Mostrar el campo de fecha de asiento y permitir su edición en el diario contable y de caja",
        "icon": "<i class='fas fa-calendar-alt primary--text'></i>"
    },
    "CanAddFutureDate": {
        "title": "Posibilidad de agregar fechas futuras a las facturas y elementos",
        "icon": "<i class='mdi mdi-sort-calendar-descending primary--text text-h5'></i>"
    },
    "ReverseCurrencyPrice": {
        "title": "Invertir la dirección del cálculo del precio de la moneda dentro de los diarios contables y de efectivo al usar una moneda diferente a la del sistema",
        "icon": "<i class='mdi mdi-swap-vertical primary--text text-h5'></i>"
    },
    "UseMaterialSerialNumber": {
        "title": "Mostrar el número de serie del material en las facturas",
        "icon": "<i class='mdi mdi-barcode-scan primary--text text-h5 mt-2'></i>"
    },
    "ShowMaterialSpecifications": {
        "title": "Mostrar las especificaciones del material en las facturas y la visualización del precio",
        "icon": "<i class='fas fa-info primary--text me-1'/>"
    },
    "DuplicateSerialNumAlert": {
        "title": "Alerta de número de serie duplicado entre materiales",
        "icon": "<i class='far fa-clone primary--text me-1'></i>"
    },
    "UseRandomNumber": {
        "title": "Codificar número de cotización al imprimir",
        "icon": "<i class='mdi mdi-counter primary--text text-h5 mt-2'></i>"
    },
    // translate to spanish 
    "UseInvoiceDateInsteadOfCurrentDate": {
        "title": "Mostrar fecha de factura en lugar de fecha actual al exportar",
        "icon": "<i class='mdi mdi-calendar primary--text text-h5 mt-2'></i>"
    },
    "ProfessionalAccountingColorMode": {
        "title": "Modo de coloración avanzada",
        "icon": "<i class='mdi mdi-palette-advanced primary--text me-1'></i>"
    },
    "hideDeleteBondButton": {
        "title": "Ocultar botón de eliminar en diarios de contabilidad y de caja",
        "icon": "<i class='fas fa-trash-alt primary--text me-1'></i>"
    }

  };
  